var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgViewer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.64 45.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "t15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.95 38a4.18 4.18 0 0 1-4.45-3.5c-2.85-2.1-4.5-5.7-4.5-10.77V.47L6.62.94v9.15H0v7.56h6.62V33c0 8.86 5 13.25 12.74 13a19.62 19.62 0 0 0 7.27-1.51L24.18 37a10 10 0 0 1-4.23 1z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.71 10.08h-4.3V0L11 .47v23.26c0 5.07 1.66 8.67 4.51 10.77a7.26 7.26 0 0 1-.17-1.5V17.64h9.86v-7.56z",
    fill: "#c69c6d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgViewer);
export default __webpack_public_path__ + "static/media/svg-viewer.5438d5247288950d1ff64787dd23e6e1.svg";
export { ForwardRef as ReactComponent };